<template>
    <div>
        <v-server-table ref="jobsiteCheckInTable" url="/jobsites/check-in/list" :columns="columns" :options="options">

            <div slot="afterFilterWrapper" class="ml-md-2 ml-0 mt-md-0 mt-2 mb-md-0 mb-3 float-md-left">
                <div class="clearfix d-md-none d-block"></div>

                <div class="float-left mr-2">
                    <table-filters-2
                        ref="jobsitecheckInFilters"
                        v-bind:filters="filters"
                        :emptyFilters="filterDefs"
                        :filterKey="filterKey"
                        @filtersChanged="refreshTableData"
                        @filtersCleared="filtersCleared">
                        <template slot-scope="slotProps">
                            <div class="d-inline-block">
                                <multi-select v-model="slotProps.filters['jobsite_check_ins.check_in_type']" :btnLabel="(values) => ('Check In/Out ('+values.length+')')" :selectOptions="checkOutOptions" :options="{multi: false}"></multi-select>
                            </div>
                            <div class="d-inline-block">
                                <multi-select v-model="slotProps.filters['jobsite_check_ins.guest_or_employee']" :btnLabel="(values) => ('People ('+values.length+')')" :selectOptions="typeOptions" :options="{multi: false}"></multi-select>
                            </div>
                            <div class="d-inline-block" style="width: 250px;" v-if="!jobsite_id">
                                <jobsite-select :selectedValues="slotProps.filters['jobsite_check_ins.jobsite_id']" v-on:vselected="((data) => { slotProps.filters['jobsite_check_ins.jobsite_id'] = data || {};  })" :forFilters="true" />
                            </div>
                            <div class="d-inline-block" style="width: 250px;" v-if="!employee_id">
                                <employee-select :selectedValues="slotProps.filters['jobsite_check_ins.employee_id']" v-on:vselected="((data) => { slotProps.filters['jobsite_check_ins.employee_id'] = data || {};  })" :forFilters="true" />
                            </div>
                        </template>
                    </table-filters-2>
                </div>

                <button type="button" class="btn btn-outline-success" v-on:click="exportTable()" :disabled="exportingTable">
                    <template v-if="!exportingTable"><i class="fa fa-file-excel-o"></i> Export</template>
                    <template v-else><i class="fa fa-circle-o-notch fa-spin"></i> Exporting</template>
                </button>
            </div>

            <template slot="id" slot-scope="props">
                <a href="javascript:void(0)" title="View COVID Form" class="btn btn-sm btn-light" v-on:click="editCheckIn(props.row)">
                    <i class="fa fa-edit"></i> Edit
                </a>
            </template>

            <template slot="JobsiteName" slot-scope="props">
                <router-link :to="`/jobsites/view/${props.row.jobsite_id}`" v-if="props.row.JobsiteName">
                    {{ props.row.JobsiteNumber }} - {{ props.row.JobsiteName }}
                </router-link>
            </template>

            <template slot="person_name" slot-scope="props">
                <router-link v-if="props.row.employee_id" :to="`/employees/view/${props.row.employee_id}`">
                    {{ props.row.FirstName }} {{ props.row.LastName }} - {{ props.row.EmployeeNumber }}
                </router-link>
                <span v-else>{{ props.row.person_name }} <span class="badge badge-secondary">Guest</span></span>
            </template>

            <template slot="check_in_at" slot-scope="props">
                {{ props.row.check_in_at | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm a") }}
            </template>

            <template slot="check_out_at" slot-scope="props">
                <span v-if="props.row.check_out_at">{{ props.row.check_out_at | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm a") }}</span>
                <span v-else class="badge badge-warning">Pending Check Out</span>
            </template>

            <template slot="signature_file_id" slot-scope="props">
                <a :href="`/files/view/${props.row.signature_file_id}`" target="_blank" title="View Signature" v-if="props.row.signature_file_id"><i class="fa fa-pencil-square"></i> View</a>
            </template>

        </v-server-table>

        <b-modal
            v-model="show_check_in_edit"
            title="Edit Check In/Out"
            ok-title="Update"
            ok-variant="success"
            size="lg"
            no-fade
            @hide="handleHide"
            @hidden="handleHidden"
            @ok="handleOk"
            ref="editCheckInModal"
            :no-close-on-backdrop="true"
            scrollable>

            <div style="min-height: 300px;">
                <div class="row">
                    <label class="col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right">
                        Jobsite:
                    </label>
                    <div class="col-lg-6 col-md-6 col-sm-8">
                        {{ edit_check_in.JobsiteNumber }} - {{ edit_check_in.JobsiteName }}
                    </div>
                </div>
                <div class="row">
                    <label class="col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right">
                        <span v-if="edit_check_in.employee_id">Employee:</span>
                        <span v-else>Guest:</span>
                    </label>
                    <div class="col-lg-6 col-md-6 col-sm-8">
                        <span v-if="edit_check_in.employee_id">{{ edit_check_in.FirstName }} {{ edit_check_in.LastName }} - {{ edit_check_in.EmployeeNumber }}</span>
                        <span v-else>{{ edit_check_in.person_name }} - {{ edit_check_in.person_company }}</span>
                    </div>
                </div>

                <div class="row mb-3">
                    <label class="col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right">
                        Check In:
                    </label>
                    <div class="col-lg-4 col-md-4 col-sm-8">
                        <input type="date" v-model="edit_check_in.check_in_date" class="form-control" />
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-8">
                        <input type="time"  v-model="edit_check_in.check_in_time" class="form-control" />
                    </div>
                </div>

                <div class="row">
                    <label class="col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right">
                        Check Out:
                    </label>
                    <div class="col-lg-4 col-md-4 col-sm-8">
                        <input type="date" v-model="edit_check_in.check_out_date" class="form-control" />
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-8">
                        <input type="time"  v-model="edit_check_in.check_out_time" class="form-control" />
                    </div>
                </div>
            </div>

        </b-modal>
    </div>
</template>

<script>
    import filterExtractor from '@/helpers/TableFilterExtractor';
    import moment from 'moment-timezone';

    export default {
        props: {
            jobsite_id: {
                type: Number,
                default: null,
            },
        },

        data() {
            return {
                edit_check_in: {},
                show_check_in_edit: false,
                exportingTable: false,
                userTimezone: this.$store.state.user.timezone,
                columns: ['id', 'JobsiteName', 'person_name', 'person_company', 'check_in_at', 'check_out_at', 'total_hours'],
                options: {
                    headings: {
                        id: 'Actions',
                        JobsiteName: 'Jobsite',
                        person_name: 'Employee/Guest',
                        person_company: 'Company',
                        check_in_at: 'Check In',
                        check_out_at: 'Check Out',
                        total_hours: 'Total Hours',
                    },
                    orderBy: {
                        ascending: false,
                        column: 'jobsite_check_ins.check_in_at',
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        this.$emit('checkInListCount', response.data.count);

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        //Send it
                        data.employee_id = this.employee_id;
                        data.jobsite_id = this.jobsite_id;

                        //Parse the filters
                        data.filters = filterExtractor.extractFilters(this.filters);

                        //Send it
                        return data;
                    },
                    uniqueKey: 'id',
                },

                filterDefs: {
                    'jobsite_check_ins.jobsite_id' : {},
                    'jobsite_check_ins.employee_id' : {},
                    'jobsite_check_ins.check_in_type': [],
                    'jobsite_check_ins.guest_or_employee': [],
                },

                filterKey: 'checkInFilters',

                checkOutOptions: [
                    {id: 'check_in_only', name: 'Actively Checked In'},
                    {id: 'check_out_at', name: 'Completed Check Out'},
                ],

                typeOptions: [
                    {id: 'Guest', name: 'Guests'},
                    {id: 'Employee', name: 'Employees'},
                ],
            }
        },

        watch: {
            appliedFilter(newVal, oldVal){
                //Call the helper
                this.checkForAppliedFilter();
            },
        },

        computed: {

            filters(){
                //Check State
                if(this.$store.state.tableFilters.filters[this.filterKey])
                {
                    //Send it
                    return this.$store.state.tableFilters.filters[this.filterKey];
                }

                //Return Definition
                return JSON.parse(JSON.stringify(this.filterDefs));
            },

            appliedFilter(){
                //Send it
                return this.$store.state.appliedFilters[this.filterKey] ? this.$store.state.appliedFilters[this.filterKey] : null;
            },
        },

        methods: {

            refreshTableData(filters) {
                //Set the data
                this.$refs.jobsiteCheckInTable.setPage(1);
                //this.$refs.jobsiteCheckInTable.getData();
            },

            filtersCleared() {
                //Reset
                this.refreshTableData();

                //Reset the Columns
                this.$refs.customFormTableFilters.resetColVis(this.$refs.jobsiteCheckInTable);
            },

            setUserFilterData(){
                //Call the Helper
                this.$refs.customFormsSavedFilters.setFilterParams(this.$refs.jobsiteCheckInTable);
            },

            checkForAppliedFilter(){
                //Check if
                if(!this.allowFilterSaving || !this.appliedFilter)
                {
                    return;
                }

                //Call the helper
                this.$refs.customFormTableFilters.setColVis(this.$refs.jobsiteCheckInTable);
            },

            editCheckIn(check_in){
                //Set it
                this.edit_check_in = check_in

                //setup
                var time_in = new moment(this.edit_check_in.check_in_at);

                //Format the Date and Time Fields
                this.edit_check_in.check_in_date = time_in.format('YYYY-MM-DD');
                this.edit_check_in.check_in_time = time_in.tz(this.userTimezone).format('HH:mm');

                //Check out time
                if(this.edit_check_in.check_out_at)
                {
                    //setup
                    var time_out = new moment(this.edit_check_in.check_out_at);

                    //Format the Date and Time Fields
                    this.edit_check_in.check_out_date = time_out.format('YYYY-MM-DD');
                    this.edit_check_in.check_out_time = time_out.tz(this.userTimezone).format('HH:mm');
                }

                //Set helper
                this.show_check_in_edit = true;
            },

            handleHide(bvEvt) {
                //debugging
                if(this.$root.debug)
                {
                    //console.log('Hiding Modal');
                }
            },

            handleHidden(bvEvt) {
                //Reset the values
                this.errors = {};
                this.show_check_in_edit = false;
                this.edit_check_in = {};
            },

            handleOk(bvEvt) {
               //Stops the modal from closing
               bvEvt.preventDefault();

               //Do it
               this.saveCheckIn();
            },

            saveCheckIn(){
                //Check In Validation
                if( (this.edit_check_in.check_in_date && !this.edit_check_in.check_in_time) || (!this.edit_check_in.check_in_date && this.edit_check_in.check_in_time) )
                {
                    //Alert the user
                    this.$toastr.warning('Check In Date & Time are required.');

                    //Stop Hree
                    return;
                }

                //Basic Front End Validiation
                if( (this.edit_check_in.check_out_date && !this.edit_check_in.check_out_time) || (!this.edit_check_in.check_out_date && this.edit_check_in.check_out_time) )
                {
                    //Alert the user
                    this.$toastr.warning('Check Out Date & Time are required together. Leave both blank if you do not wish to update the checkout');

                    //Stop Hree
                    return;
                }

                //Format Some Stuff
                var payload = {
                    check_in_at: this.edit_check_in.check_in_date + ' ' + this.edit_check_in.check_in_time,
                };

                //Check Out
                if(this.edit_check_in.check_out_date)
                {
                    payload.check_out_at = this.edit_check_in.check_out_date + ' ' + this.edit_check_in.check_out_time;
                }

                //Send it
                this.$http.post('/jobsites/check-in/edit/'+this.edit_check_in.id, payload)
                    .then(response => {
                        //Alert
                        this.$toastr.success('Check In Updated');

                        //Refresh the List?
                        this.refreshTableData();

                        //Close the Model
                        this.show_check_in_edit = false;
                    })
                    .catch(err => {
                        //Alert the user
                        this.$toastr.error(err.response.data, 'Failed to Export Jobsite Check Ins');
                    })
                    .then(response => {
                        //reset
                        this.exportingTable = false;
                    });
            },

            exportTable(){
                //Loading indicator
                this.exportingTable = true;

                //Build the payload
                var payload = {
                    jobsite_id: this.jobsite_id,
                    query: (this.$refs.jobsiteCheckInTable.getRequestParams()).query,
                    orderBy: this.$refs.jobsiteCheckInTable.options.orderBy.column,
                    ascending: this.$refs.jobsiteCheckInTable.options.orderBy.ascending,
                    table: 'jobsiteCheckInTable',
                    columns: this.$refs.jobsiteCheckInTable.columns,
                    employee_id: this.employee_id,
                    filters: filterExtractor.extractFilters(this.filters),
                };

                //Send it
                this.$http.get('/jobsites/check-in/list?export=true', payload)
                    .then(response => {
                        //Open the new window
                        window.open(response.data);
                    })
                    .catch(err => {
                        //Alert the user
                        this.$toastr.error(err.response.data, 'Failed to Export Jobsite Check Ins');
                    })
                    .then(response => {
                        //reset
                        this.exportingTable = false;
                    });
            }
        },

        mounted(){
            //Check for a saved filter
            this.checkForAppliedFilter();

            //Check for Filter ID
            if(this.filterId)
            {
                this.$refs.customFormsSavedFilters.setSavedFilter(this.filterId);
            }
        }
    }
</script>
